import { render } from "./Directive.vue?vue&type=template&id=55a35c4b&scoped=true"
import script from "./Directive.vue?vue&type=script&lang=ts"
export * from "./Directive.vue?vue&type=script&lang=ts"

import "./Directive.vue?vue&type=style&index=0&id=55a35c4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55a35c4b"

export default script